import { ChangeDetectionStrategy, Component, inject, signal, viewChild } from '@angular/core';
import { OauthLoginComponent } from '../oauth-login/oauth-login.component';
import { OtpComponent, OtpLoad, SALES_EMAIL } from '../../components/otp/otp.component';
import { CarouselComponent } from '../../components/carousel/carousel.component';
import { OauthService } from '../../services/oauth/oauth.service';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs';
import { AuthStateService } from '../../services/auth/auth-state.service';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutes } from '../../routes/common.routes';

@Component({
  selector: 'app-oauth-parent',
  imports: [OauthLoginComponent, OtpComponent, CarouselComponent],
  templateUrl: './oauth-parent.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OauthParentComponent {
  #oauthService = inject(OauthService);
  #authState = inject(AuthStateService);
  #router = inject(Router);
  #translate = inject(TranslateService);
  isLogin = signal(true);
  channelValue = signal<string>('');
  otpComponent = viewChild(OtpComponent);

  onLoggedIn(email: string): void {
    this.isLogin.set(false);
    this.channelValue.set(email);
  }

  onVerified(details: OtpLoad): void {
    this.#oauthService
      .loginWithEmail({ ...details, email: details.value })
      .pipe(switchMap(() => this.#authState.getUserDetails()))
      .subscribe({
        next: () => this.#router.navigate([AppRoutes.dashboard]),
        complete: () => {
          if (this.#oauthService.status() === 'DEACTIVATED') {
            this.channelValue.set(SALES_EMAIL);
            this.otpComponent()?.displayMessage.set(this.#translate.instant('MESSAGES.PROMPTS.ACCOUNT_DEACTIVATED'));
          }
        },
      });
  }
}
